export default __webpack_public_path__ + "static/media/gamification-scratch-midnight.13995960.png";